import React, { useEffect, useState } from 'react';
import {
  CreateBase,
  SimpleForm,
  TextInput,
  BooleanInput,
  useNotify,
  useRedirect,
  useCreate,
  required,
  useDataProvider,
  AutocompleteArrayInput,
} from "react-admin";
import Box from "@mui/material/Box";
import { Descriptions } from 'antd';

const DepartmentCreate: React.FC = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  const [create] = useCreate();
  const [loading, setLoading] = useState(true);

  // ----------------------
  // 加载部门列表
  // ----------------------
//   useEffect(() => {
//     setLoading(true);

//     dataProvider.getList('role', {
//       pagination: { page: 1, perPage: 1000 },
//       sort: { field: 'id', order: 'ASC' },
//       filter: {}
//     })
//       .then((res) => {
//         setRoles(res.data);
//         setLoading(false);
//       })
//       .catch((e) => {
//         console.error(e);
//         notify('Error loading roles', { type: 'warning' });
//         setLoading(false);
//       });
//   }, [dataProvider, notify]);

//   if (loading) return <span>Loading...</span>;

  // ----------------------
  // 保存操作
  // ----------------------
  const handleSave = async (data: any) => {
    try {

      const payload = {
        departmentName: data.departmentName,
        description: data.description,
      };

      await create('permissionDepartment', { data: payload });

      notify('Department created successfully', { type: 'success' });
      redirect('list', 'permissionDepartment');
    } catch (error) {
      console.error('Create department error:', error);
      notify('Create failed', { type: 'error' });
    }
  };

  return (
    <CreateBase resource="permissionDepartment">
      <SimpleForm sx={{ backgroundColor: '#ffffff', padding: '36px' }} onSubmit={handleSave}>
        <Box display="flex" flexWrap="wrap" gap={2}>

          {/* 部门名称 */}
          <Box flex="1 1 48%">
            <TextInput
              source="departmentName"
              label="Department Name"
              fullWidth
              validate={[required()]}
            />
          </Box>

          {/* 部门描述 */}
          <Box flex="1 1 48%">
            <TextInput
              source="description"
              label="Department Description"
              fullWidth
            />
          </Box>
        </Box>
      </SimpleForm>
    </CreateBase>
  );
};

export default DepartmentCreate;
